<!-- Layout card: franja de cupos en «Próximo pago» -->
<div *ngIf="layout === 'card'" class="extra-users extra-users--card">
    <div class="extra-users__icon" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
                stroke="#7c3aed"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    </div>
    <div class="extra-users__balance">
        <div class="extra-users__label">{{ cardTitle }}</div>
        <div class="extra-users__amount">
            <span class="extra-users__amount-n">{{ totalSeats }}</span>
            <span class="extra-users__amount-u">{{ headerLabel }}</span>
        </div>
        <p class="extra-users__extras mb-0">{{ cardExtrasLine }}</p>
    </div>
    <p class="extra-users__hint mb-0">{{ occupancyLine }}</p>
    <button type="button" class="btn extra-users__btn-outline" routerLink="/comercio/usuarios-asociados">Gestionar usuarios</button>
</div>

<!-- Layout modal: «Usuarios del comercio» al confirmar el pago (todos los cupos, ocupados o no) -->
<section *ngIf="layout === 'modal'" class="extra-users extra-users--modal" aria-label="Usuarios del comercio">
    <div class="extra-users__head">
        <h3 class="extra-users__title">Usuarios del comercio</h3>
        <span class="extra-users__usage">{{ usageLine }}</span>
    </div>

    <div class="extra-users__panel">
        <div class="extra-users__note extra-users__note--ok" *ngIf="freeSeats > 0" role="status">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M8 12.5l2.5 2.5L16 9.5"></path>
            </svg>
            <span class="extra-users__note-text">{{ freeSeatsLine }}</span>
        </div>
        <div class="extra-users__note extra-users__note--warn" *ngIf="freeSeats === 0" role="status">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M12 7.5v5.5M12 16.5v.1"></path>
            </svg>
            <span class="extra-users__note-text">{{ fullSeatsLine }}</span>
        </div>

        <div class="extra-users__extras-row">
            <div class="extra-users__extras-copy">
                <span class="extra-users__extras-title">Cupos adicionales</span>
                <span class="extra-users__extras-price">{{ resolvedExtraUserPriceUsd | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}/mes c/u · se cobran aunque no estén asignados</span>
            </div>
            <div class="extra-users__stepper" role="group" aria-label="Cupos adicionales" *ngIf="canEdit; else readonlyExtras">
                <button type="button" class="extra-users__step" aria-label="Quitar cupo" [disabled]="!canDecrement" (click)="decrement()">−</button>
                <span class="extra-users__step-value" aria-live="polite">{{ pendingPurchasedUsers }}</span>
                <button type="button" class="extra-users__step" aria-label="Sumar cupo" [disabled]="atSeatLimit" (click)="increment()">+</button>
            </div>
            <ng-template #readonlyExtras>
                <span class="extra-users__step-value extra-users__step-value--readonly">{{ pendingPurchasedUsers }}</span>
            </ng-template>
        </div>
        <p class="extra-users__step-hint mb-0" *ngIf="decrementHint">{{ decrementHint }}</p>
        <p class="extra-users__step-hint mb-0" *ngIf="canEdit && atSeatLimit">Llegaste al máximo de {{ maxPurchasedUsers }} cupos adicionales.</p>

        <button type="button" class="extra-users__toggle" [attr.aria-expanded]="showUsers" (click)="toggleUsers()">
            {{ showUsers ? 'Ocultar usuarios' : 'Ver quién usa cada cupo' }}
            <svg
                class="extra-users__chevron"
                [class.extra-users__chevron--open]="showUsers"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.2"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
            >
                <path d="M6 9l6 6 6-6"></path>
            </svg>
        </button>

        <ul class="extra-users__list" *ngIf="showUsers" tabindex="0" aria-label="Lista de usuarios">
            <li class="extra-users__row" *ngFor="let row of seatRows; trackBy: trackSeatRow">
                <div class="extra-users__avatar" [class.extra-users__avatar--empty]="!row.occupant" aria-hidden="true">
                    <ng-container *ngIf="row.occupant; else emptyAvatar">{{ (row.occupant.name || '').charAt(0) }}{{ (row.occupant.lastName || '').charAt(0) }}</ng-container>
                    <ng-template #emptyAvatar>+</ng-template>
                </div>
                <div class="extra-users__person">
                    <div class="extra-users__name">{{ row.displayName }}</div>
                    <div class="extra-users__role" *ngIf="row.occupant">{{ row.roleLabel }}{{ row.isCurrentUser ? ' · Eres tú' : '' }}</div>
                    <div class="extra-users__role" *ngIf="!row.occupant">Listo para crear un usuario</div>
                </div>
                <span class="extra-users__badge extra-users__badge--included" *ngIf="row.kind === 'included'">Incluido en tu plan</span>
                <span class="extra-users__badge extra-users__badge--extra" *ngIf="row.kind === 'extra'">
                    Adicional · {{ resolvedExtraUserPriceUsd | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}/mes
                </span>
            </li>
        </ul>
    </div>
</section>
